import styled from '@emotion/styled'
import type { FC } from 'react'

import { useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'
import Divider from '@segment/matcha/components/Divider'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import Badge from '@segment/matcha/components/Badge'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import Accordions from './Accordions'

import { data } from './data'

const copy = {
  heading: `Categories`,
}

const Categories: FC = () => {
  const theme = useTheme()
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <StyledSectionCopy>
          <Heading variant="h2" tokens={{ color: theme.palette.twilio.gray[60] }}>
            {copy.heading}
          </Heading>
          <Divider />
        </StyledSectionCopy>

        <Section.Contents>
          <AccordionsList>
            {data.map(({ slug, title, description, list, card }) => (
              <div key={slug} id={slug}>
                <CopyTextBase>
                  <CopyText.Heading variant="h2">{title}</CopyText.Heading>
                  <CopyText.Description tag="p">{description}</CopyText.Description>
                  {card ? (
                    <StyledCardBase href={getAbsoluteUrl(`/recipes${card.link}/`, pageConfig)}>
                      <Card.Body>
                        <Card.Accessories>
                          <Card.AccessoriesRow>
                            <Badge variant="outlined">{card.badge}</Badge>
                          </Card.AccessoriesRow>
                        </Card.Accessories>
                        <Card.Copy>
                          <StyledCardHeadline>{card.title}</StyledCardHeadline>
                          <StyledCardDescription>{card.description}</StyledCardDescription>
                          {card.image ? <StyledCardImage variant="fill" src={card.image} alt="" /> : null}
                        </Card.Copy>
                        <Card.Action alignment="left">
                          <ButtonText iconEnd={ChevronRightIcon}>Use this recipe</ButtonText>
                        </Card.Action>
                      </Card.Body>
                    </StyledCardBase>
                  ) : null}
                </CopyTextBase>

                <Accordions data={list} />
              </div>
            ))}
          </AccordionsList>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Heading = styled(Typography)`
  margin-bottom: 20px;
`

const Wrapper = styled.div`
  max-width: 1004px;
  margin: 0 auto;
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 40px;
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  width: 100%;
`

const AccordionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
`

const StyledCardBase = styled(CardBase)`
  padding-top: 40px;
  padding-bottom: 16px;
`

const StyledCardHeadline = styled(Card.Headline)`
  overflow: unset;
`

const StyledCardDescription = styled(Card.Description)`
  overflow: unset;
`

const StyledCardImage = styled(Card.Image)`
  width: 100%;
  height: 100%;
  aspect-ratio: auto;
`

export default Categories
